const TablesIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.46683 5.73334H2.70016C3.5985 5.73334 4.3335 6.46834 4.3335 7.36668V15.5333C4.3335 16.4317 3.5985 17.1667 2.70016 17.1667H2.46683C1.5685 17.1667 0.833496 16.4317 0.833496 15.5333V7.36668C0.833496 6.46834 1.5685 5.73334 2.46683 5.73334ZM9.00016 0.833344C9.8985 0.833344 10.6335 1.56834 10.6335 2.46668V15.5333C10.6335 16.4317 9.8985 17.1667 9.00016 17.1667C8.10183 17.1667 7.36683 16.4317 7.36683 15.5333V2.46668C7.36683 1.56834 8.10183 0.833344 9.00016 0.833344ZM15.5335 10.1667C16.4318 10.1667 17.1668 10.9017 17.1668 11.8V15.5333C17.1668 16.4317 16.4318 17.1667 15.5335 17.1667C14.6352 17.1667 13.9002 16.4317 13.9002 15.5333V11.8C13.9002 10.9017 14.6352 10.1667 15.5335 10.1667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TablesIcon;
